import { useState, useEffect } from "react";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi2";
const testimonials = [
  {
    name: "Niranjan Namadar",
    location: "Bangalore",
    image: require("./testi-2.png"),
    review:
      "I have had an exceptional experience with Sai Suchith Pest Control. They are by far the best service provider I've come across. Their professionalism and customer-centric approach truly set them apart.",
  },
  {
    name: "Kavya Siddaraju",
    location: "Mangaluru",
    image: require("./testi-2.png"),
    review:
      "It is one of the best services I have experienced from across all the other companies. Excellent service! Very professional team, quick response, and effective pest control.",
  },
  {
    name: "Prathamesh Namadar",
    location: "Hubballi",
    image: require("./testi-3.png"),
    review: "Good Service.",
  },
  {
    name: "Sharanappa Iragar",
    location: "Hubballi",
    image: require("./testi-4.png"),
    review: "Giving best service ever 🙏.",
  },
  {
    name: "Mahendra B K",
    location: "Hubballi",
    image: require("./testi-4.png"),
    review: "Super",
  },
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextTestimonial, 3000);
    return () => clearInterval(interval);
  }, [currentIndex, isPaused]);

  return (
    <div
      className="min-h-[560px] sm:h-[450px] flex flex-col items-center pt-16 pb-16 mt-16 bg-gradient-to-r from-red-300 to-red-900 px-6 sm:px-4"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <h6 className="text-white text-2xl font-semibold sm:text-lg">
        TESTIMONIALS
      </h6>
      <h1 className="font-bold font-serif text-5xl pt-5 text-white sm:text-3xl text-center">
        Customer Reviews
      </h1>

      <img
        src={testimonials[currentIndex].image}
        className="h-[150px] w-[150px] sm:h-[100px] sm:w-[100px] mt-6 bg-red-200 border-2 rounded-full object-cover"
        alt={testimonials[currentIndex].name}
      />

      <p className="pt-8 text-zinc-100 text-lg text-center px-6 sm:px-2 sm:text-base max-w-8xl">
        {testimonials[currentIndex].review}
      </p>
      <p className="mt-4  text-xl sm:text-base">⭐⭐⭐⭐⭐</p>

      {/* Arrows */}
      <div className="relative w-full max-w-6xl mt-5">
        <HiOutlineArrowLeft
          className="absolute left-0 text-3xl lg:ml-44 sm:left-2 top-0 font-medium cursor-pointer text-white hover:text-black "
          onClick={prevTestimonial}
        />
        <HiOutlineArrowRight
          className="absolute right-0 text-3xl lg:mr-44 sm:right-2 top-0 font-medium cursor-pointer text-white hover:text-black"
          onClick={nextTestimonial}
        />
      </div>

      <h6 className="text-xl font-bold text-black sm:pt-0 sm:text-lg">
        {testimonials[currentIndex].name}
      </h6>
      {/* <h6 className="pt-1 text-white text-lg sm:text-base">
        {testimonials[currentIndex].location}
      </h6> */}

      {/* Dots */}
      <div className="flex gap-2 mt-8">
        {testimonials.map((_, index) => (
          <div
            key={index}
            className={`h-3 w-3 rounded-full transition-all duration-300 ${
              index === currentIndex ? "bg-white" : "bg-gray-500"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
}
